import handleResult from '../common/handleResult';
import requestJs from '../common/request';
import serviceConfig from '../api/serviceConfig';

//根据token获取登录用户信息
export const getLoginUserInfo = param => {
  return requestJs.requestMethod(param,serviceConfig.interfacePath.user.personalInfo,serviceConfig.interfaceGroupId.user).then(res => handleResult.common(res,true));
};

//获取班级列表
export const getlistTeacherClassInfo = param => {
  return requestJs.requestMethod(param,serviceConfig.interfacePath.user.listTeacherClassPath,serviceConfig.interfaceGroupId.user).then(res => handleResult.common(res,true));
};

//获取学生列表（根据班级ID+老师id）
export const getlistClassStudentInfo = param => {
  return requestJs.requestMethod(param,serviceConfig.interfacePath.user.listClassStudent,serviceConfig.interfaceGroupId.user).then(res => handleResult.common(res));
};

//获取个人信息
export const getpersonalInfo = param => {
  return requestJs.requestMethod(param,serviceConfig.interfacePath.user.personalInfo,serviceConfig.interfaceGroupId.user).then(res => handleResult.common(res));
};

//获取个人发布消息列表
export const getNoticeInfo = param => {
  return requestJs.requestMethod(param,serviceConfig.interfacePath.user.noticeInfo,serviceConfig.interfaceGroupId.user).then(res => handleResult.common(res));
};

//获取个人接收消息列表
export const getReceiveNoticeInfo = param => {
    return requestJs.requestMethod(param,serviceConfig.interfacePath.user.receiveNoticeInfo,serviceConfig.interfaceGroupId.user).then(res => handleResult.common(res));
};

//获取公告详情
export const getNoticeDetail = param => {
  return requestJs.requestMethod(param,serviceConfig.interfacePath.user.noticeDetail,serviceConfig.interfaceGroupId.user).then(res => handleResult.common(res));
};

//发送消息
export const sendNotice = param => {
    return requestJs.requestMethod(param,serviceConfig.interfacePath.user.sendNotice,serviceConfig.interfaceGroupId.user).then(res => handleResult.common(res));
}

//删除该公告
export const deleteNotice = param => {
    return requestJs.requestMethod(param,serviceConfig.interfacePath.user.deleteNotice,serviceConfig.interfaceGroupId.user).then(res => handleResult.common(res));
}

//s删除接收到的消息
export const deleteReceiveNotice = param =>{
  return requestJs.requestMethod(param,serviceConfig.interfacePath.user.deleteReceiveNotice,serviceConfig.interfaceGroupId.user).then(res=>handleResult.common(res));
}

//获取配置信息
export const getConfigInfo = param => {
    return requestJs.requestMethod(param,serviceConfig.interfacePath.user.configUrl,serviceConfig.interfaceGroupId.config).then(res => handleResult.common(res));
};

//教研员角色，获取学校信息
export const getSchoolInfo = param => {
    return requestJs.requestMethod(param,serviceConfig.interfacePath.user.schoolInfo,serviceConfig.interfaceGroupId.user).then(res => handleResult.common(res));
};

//查询学校下的班级
export const getClassInfoUnderSchool = param => {
    return requestJs.requestMethod(param,serviceConfig.interfacePath.user.schoolClassInfo,serviceConfig.interfaceGroupId.user).then(res => handleResult.common(res));
};

//查询学校下的班级
export const getClassInfoUnderArea = param => {
    return requestJs.requestMethod(param,serviceConfig.interfacePath.user.areaSchoolInfo,serviceConfig.interfaceGroupId.user).then(res => handleResult.common(res));
};

//根据学校用户的学校id查询的学校老师列表
export const listSchoolTeacher = param => {
    return requestJs.requestMethod(param,serviceConfig.interfacePath.user.listSchoolTeacher,serviceConfig.interfaceGroupId.user).then(res => handleResult.common(res));
};
//区教研员查询该区域的统计信息
export const statisticAreaSchool=param =>{
  return requestJs.requestMethod(param,serviceConfig.interfacePath.user.statisticAreaSchool,serviceConfig.interfaceGroupId.user).then(res =>handleResult.common(res));
}
//查询角色权限列表
export const listRoleAuth = param => {
    return requestJs.requestMethod(param,serviceConfig.interfacePath.user.auth_listRoleAuth,serviceConfig.interfaceGroupId.auth).then(res => handleResult.common(res));
};
//查询学校列表
export const listAreaSchool = param => {
    return requestJs.requestMethod(param,serviceConfig.interfacePath.user.listAreaSchool,serviceConfig.interfaceGroupId.user).then(res => handleResult.common(res));
};

//查询年级下的班级列表
export const listGradeSchool = param => {
    return requestJs.requestMethod(param,serviceConfig.interfacePath.user.listGradeSchool,serviceConfig.interfaceGroupId.user).then(res => handleResult.common(res));
};

//查询老师的班级
export const listTeacherSubjectClass = param => {
    return requestJs.requestMethod(param,serviceConfig.interfacePath.user.listTeacherSubjectClass,serviceConfig.interfaceGroupId.user).then(res => handleResult.common(res));
};



// WEBPACK FOOTER //
// ./src/api/usercenter.js